export default "<p>\r\n  summary-report works!\r\n  {{summaryData}}\r\n</p>\r\n"